import OrderArticle from "./models/order/OrderArticle.ts";
import store from "./redux/store.tsx";
import _ from "lodash";
import { selectAccountTotalValue } from "./redux/accountSlice.tsx";
import { getDeliveryFee, getTransactionFee } from "./order/addVariousItemsToOrder.ts";
import { mapOrderArticleForRequest } from "./useSendCheckout2.tsx";

type OrderV2 = {
  orderArticles: (Omit<OrderArticle, "article"> & { article?: { id: string } })[];
  tipAmount: number;
  deliveryFee: number;
  transactionFee: number;
  totalAmount: number;
};

export function getOrderV2(copyItems: OrderArticle[]): OrderV2 | undefined {
  if (store.getState().global.salesarea.ordering_version === "V2") {
    return {
      orderArticles: _.map(copyItems, mapOrderArticleForRequest),
      totalAmount: selectAccountTotalValue(store.getState()),
      tipAmount: store.getState().account.credits.tipAmount,
      deliveryFee: getDeliveryFee(),
      transactionFee: getTransactionFee(),
    };
  } else {
    return undefined;
  }
}
